{
  "remove": "Удалить",
  "empty_option": "Ничего не найдено"
}
